const notificationDetailModal = {
  from: "From",
};

export default notificationDetailModal;
